<div>
	<div class="moodCheck-header">
		<h3 translate>moodcheck.people.title</h3>
		<span translate>moodcheck.people.select</span>
	</div>
	<div class="app-l-mood-check__add">
		<div class="app-l-mood-check__add-block">
			<button
				type="button"
				class="app-l-mood-check__add-label"
				(click)="onMore()"
			>
				<svg-icon icon="plus"></svg-icon>
				<span translate>moodcheck.addOrEditPeople</span>
			</button>
		</div>
	</div>
	<div
		class="app-l-mood-check__options"
		role="group"
		[attr.aria-label]="'moodcheck.people.title' | translate">
		<div
			class="app-l-mood-check__item"
			*ngFor="let option of getOptions(options);let index = index"
		>
			<div
				class="app-l-mood-check__block"
				*ngIf="option.show === '1' || option.show === 1 || option.custom === true"
			>
				<button
					type="button"
					role="checkbox"
					[attr.aria-checked]="!!option.isSelected"
					[attr.aria-label]="option.name"
					class="box"
					[ngClass]="{'active': option.isSelected}"
					(click)="toggleOption(option)"
				>
					<span class="app-l-mood-check__option-name"
						>{{option.name | truncate: 30}}</span
					>
					<span class="app-l-mood-check__select-icon">
						<!-- <img
                            alt="select"
                            class="selectIcon active-open"
                            [ngClass]="{'hide': option.isSelected}"
                            src="/assets/img/moodcheck/new/selected-icon.svg"

                        />
                        <img
                            alt="select"
                            class="selectIcon"
                            [ngClass]="{'active': option.isSelected}"
                            src="/assets/img/moodcheck/new/addcheck.svg"
                        /> -->
						<svg-icon
							icon="tick-circle"
							class="w-100 h-100"
						></svg-icon>
					</span>
				</button>
			</div>
		</div>
	</div>
</div>
